var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64243 19.3305C5.8276 19.1454 6.08221 19.0373 6.35225 19.0373H30.8411C31.2886 19.0373 31.5123 19.5774 31.196 19.8938L26.3584 24.7313C26.1732 24.9165 25.9186 25.0245 25.6486 25.0245H1.15976C0.712263 25.0245 0.488515 24.4844 0.804848 24.1681L5.64243 19.3305Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64243 1.26867C5.83532 1.0835 6.08993 0.975479 6.35225 0.975479H30.8411C31.2886 0.975479 31.5123 1.51556 31.196 1.83189L26.3584 6.66948C26.1732 6.85465 25.9186 6.96266 25.6486 6.96266H1.15976C0.712263 6.96266 0.488515 6.42258 0.804848 6.10625L5.64243 1.26867Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3584 10.2417C26.1732 10.0566 25.9186 9.94855 25.6486 9.94855H1.15976C0.712263 9.94855 0.488515 10.4886 0.804848 10.805L5.64243 15.6426C5.8276 15.8277 6.08221 15.9357 6.35225 15.9357H30.8411C31.2886 15.9357 31.5123 15.3957 31.196 15.0793L26.3584 10.2417Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/sol.8233b2c9.svg";
export { ForwardRef as ReactComponent };